import { render, staticRenderFns } from "./PopUpBinnacleFile.vue?vue&type=template&id=1633e4c2&"
import script from "./PopUpBinnacleFile.vue?vue&type=script&lang=js&"
export * from "./PopUpBinnacleFile.vue?vue&type=script&lang=js&"
import style0 from "./PopUpBinnacleFile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1633e4c2')) {
      api.createRecord('1633e4c2', component.options)
    } else {
      api.reload('1633e4c2', component.options)
    }
    module.hot.accept("./PopUpBinnacleFile.vue?vue&type=template&id=1633e4c2&", function () {
      api.rerender('1633e4c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dnt/vistas/modals/PopUpBinnacleFile.vue"
export default component.exports